import {Store, StoreMethods} from '@store/@types/alt';
import RecallZoomIntegrationActions, {
  RecallZoomIntegrationActionsInterface,
} from '@store/recall/RecallZoomIntegrationActions';
import alt from 'components/Dispatcher';
import {ZoomNoteTakerStateResponse} from '@store/recall/RecallZoomIntegrationSource';

interface RecallZoomIntegrationStoreState {
  authURI: string | null;
  state: 'red' | 'green';
}

class RecallZoomIntegrationStore
  extends Store<RecallZoomIntegrationStoreState>
  implements StoreMethods<RecallZoomIntegrationActionsInterface>
{
  constructor() {
    super();
    this.state = {
      authURI: null,
      state: 'red',
    };
    this.bindActions(RecallZoomIntegrationActions);
  }

  fetchRecallZoomState(): void {
    this.setState({authURI: null, state: 'red'});
  }

  fetchRecallZoomStateError(error: Error): void {
    console.error(error);
  }

  fetchRecallZoomStateSuccess(response: ZoomNoteTakerStateResponse): void {
    this.setState({authURI: response.uri, state: response.state});
  }
}

export default alt.createStore(RecallZoomIntegrationStore);
